import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-eb83cfaa"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("請選擇寵物芭比娃娃服飾")
const _hoisted_2 = {
  key: 0,
  class: "spin"
}
const _hoisted_3 = {
  key: 1,
  class: "bg-2"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "上身套裝", -1))
const _hoisted_5 = ["src", "onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "鞋", -1))
const _hoisted_7 = ["src", "onClick"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "已選擇服飾", -1))
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "ion-text-center ion-margin-vertical" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 下一步 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_radio = _resolveComponent("ion-radio")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_ion_radio_group = _resolveComponent("ion-radio-group")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_buttons, { slot: "start" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, {
                  slot: "icon-only",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, { icon: _ctx.arrowBackOutline }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_title, { class: "ion-text-start" }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_content, { class: "ion-text-center" }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_grid, { fixed: "" }, {
          default: _withCtx(() => [
            (_ctx.loadingData)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_component_ion_spinner)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _hoisted_4,
                  _createVNode(_component_ion_radio_group, {
                    "allow-empty-selection": true,
                    modelValue: _ctx.selectedSet.upper,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedSet.upper) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_swiper, {
                        slidesPerView: 2.1,
                        breakpoints: _ctx.swiperOps.breakpoints,
                        freeMode: true,
                        cssMode: true
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.apparels.filter(a => a.type == '上身套裝'), (apparel) => {
                            return (_openBlock(), _createBlock(_component_swiper_slide, {
                              key: apparel.id
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_card, {
                                  class: "clothes-card",
                                  onClick: _withModifiers(($event: any) => (_ctx.selectApparel('upper', apparel)), ["stop"]),
                                  button: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("img", {
                                      src: apparel.photoLink,
                                      onClick: ($event: any) => (_ctx.openImageModal(apparel.photoLink))
                                    }, null, 8, _hoisted_5),
                                    _createElementVNode("p", null, [
                                      _createVNode(_component_ion_radio, { value: apparel }, null, 8, ["value"])
                                    ])
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["slidesPerView", "breakpoints"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _hoisted_6,
                  _createVNode(_component_ion_radio_group, {
                    "allow-empty-selection": true,
                    modelValue: _ctx.selectedSet.shoe,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedSet.shoe) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_swiper, {
                        slidesPerView: 2.1,
                        breakpoints: _ctx.swiperOps.breakpoints,
                        freeMode: true,
                        cssMode: true
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.apparels.filter(a => a.type == '鞋'), (apparel) => {
                            return (_openBlock(), _createBlock(_component_swiper_slide, {
                              key: apparel.id
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_card, {
                                  class: "shoe-card",
                                  onClick: _withModifiers(($event: any) => (_ctx.selectApparel('shoe', apparel)), ["stop"]),
                                  button: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("img", {
                                      src: apparel.photoLink,
                                      onClick: ($event: any) => (_ctx.openImageModal(apparel.photoLink))
                                    }, null, 8, _hoisted_7),
                                    _createElementVNode("p", null, [
                                      _createVNode(_component_ion_radio, { value: apparel }, null, 8, ["value"])
                                    ])
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["slidesPerView", "breakpoints"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _withDirectives(_createElementVNode("div", null, [
                    _hoisted_8,
                    _createElementVNode("p", null, [
                      _createElementVNode("img", {
                        class: "preview-img",
                        src: _ctx.selectedSet.previewImage,
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openImageModal(_ctx.selectedSet.previewImage)))
                      }, null, 8, _hoisted_9)
                    ])
                  ], 512), [
                    [_vShow, _ctx.selectedSet.previewImage]
                  ]),
                  _createElementVNode("p", _hoisted_10, [
                    _createVNode(_component_ion_button, {
                      size: "large",
                      shape: "round",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.closeModal())),
                      "router-link": {
            name: 'CheckoutPage',
            params: { passedCartItems: JSON.stringify([{
              product: _ctx.PRODUCT_NAME,
              unitPrice: _ctx.getOrderItemTotal(),
              quantity: 1,
              numOfPets: 1,
              selectedSet: _ctx.selectedSet
            }]) }
          }
                    }, {
                      default: _withCtx(() => [
                        _hoisted_11,
                        _createVNode(_component_ion_icon, {
                          slot: "end",
                          icon: _ctx.arrowForward
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }, 8, ["router-link"])
                  ])
                ]))
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}